/**
 * @pageName EventsDrafts
 * @slotType dashboard menu plugin
 */
export interface EventItemsBulkMoreActionsMenuParams {
  /* Selected IDs.*/ selectedIds: string[];
}
